<template>
    <div class="login">
        <div class="container">
            <div class="login__wrapper">
                <div v-if="loaderVisible" class="login__wrapper--loading">
                    <h3>Please wait a moment while we log you in.</h3>
                    <svg width="64px" height="64px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-28bb7e74=""><g id="icons-/-filled-/-layers-show" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-28bb7e74=""><path d="M23.2713354,16.0378794 C23.5208781,15.927794 23.8203293,16.0378794 23.9301281,16.298081 C24.0399268,16.5482749 23.9301281,16.8485076 23.6805854,16.9585929 L23.6805854,16.9585929 L12.2016227,21.9624709 C12.0818422,22.0125097 11.9321166,22.0125097 11.8123361,21.9624709 L11.8123361,21.9624709 L0.333373407,16.9585929 C0.0738490332,16.8485076 -0.0359497405,16.5582827 0.0738490332,16.3080888 C0.185644148,16.0578949 0.473117301,15.9478096 0.732641676,16.0578949 L0.732641676,16.0578949 L12.021952,20.9747054 L23.3112622,16.0578949 Z M23.2713354,13.0255448 C23.5208781,12.9154595 23.8203293,13.0255448 23.9301281,13.2857465 C24.0399268,13.5359404 23.9301281,13.836173 23.6805854,13.9462584 L23.6805854,13.9462584 L12.2016227,18.9501364 C12.0818422,19.0001751 11.9321166,19.0001751 11.8123361,18.9501364 L11.8123361,18.9501364 L0.333373407,13.9462584 C0.0738490332,13.8441792 -0.0359497405,13.5459481 0.0738490332,13.2957542 C0.185644148,13.0455603 0.473117301,12.935475 0.732641676,13.0455603 L0.732641676,13.0455603 L12.021952,17.9713778 L23.3112622,13.0575696 Z M0.0638673265,10.2914259 C0.175662442,10.041232 0.463135595,9.93114664 0.722659969,10.041232 L0.722659969,10.041232 L12.0059812,14.9650479 L23.2952915,10.0512397 C23.5418397,9.94115439 23.8412909,10.0512397 23.9510896,10.3114414 C24.0608884,10.5616353 23.9510896,10.8618679 23.701547,10.9719533 L23.701547,10.9719533 L12.2225843,15.9758313 C12.1028038,16.02587 11.9530782,16.02587 11.8332977,15.9758313 L11.8332977,15.9758313 L11.8023544,15.9528134 C10.3587501,15.3239511 9.08748615,14.7754166 7.9686772,14.2955075 L7.08690354,13.9179304 C1.14697273,11.3787589 0.0299238523,10.9859268 3.30551558e-15,10.5409689 L0.000317435709,10.498364 C0.00256092928,10.4697619 0.00870880005,10.4406683 0.017804874,10.4105205 L0.0335406156,10.3644379 C0.0423945408,10.3409309 0.0526379064,10.3166727 0.0638673265,10.2914259 Z M11.8223178,2.0450349 C11.9420983,1.98498837 12.0918239,1.98498837 12.2215861,2.0450349 L12.2215861,2.0450349 L23.7005488,7.04891291 C24.0998171,7.22705096 24.0998171,7.78948685 23.7005488,7.96962646 L23.7005488,7.96962646 L12.2215861,12.9735045 C12.1018056,13.0235432 11.95208,13.0235432 11.8322995,12.9735045 L11.8322995,12.9735045 L0.353336821,7.96962646 L0.343355114,7.9596187 C-0.0658948607,7.78948685 -0.0658948607,7.21904476 0.343355114,7.04891291 L0.343355114,7.04891291 Z" id="Combined-Shape" fill="#69c350" data-v-28bb7e74=""></path></g></svg>
                </div>
                <div v-else class="login__wrapper--form">
                    <h1>{{ $t('page.login.title') }}</h1>
                    <div class="login__input">
                        <label for="email">{{ $t('page.login.email') }}</label>
                        <input @keyup.enter="login()" id="email" name="email" type="email" v-model="email_address" required>
                    </div>
                    <div class="login__input">
                        <label for="password">{{ $t('page.login.password') }}</label>
                        <input @keyup.enter="login()" id="password" name="password" type="password" v-model="password" required>
                    </div>
                    <div v-if="handleErrorMessage()" class="login__error">
                        {{handleErrorMessage()}}
                    </div>
                    <div class="login__input login__input--submit">
                        <a class="registration--link" target="_blank" :href="register_url" v-html="$t('page.login.registration')"></a>
                        <btn @click="login" :text="'Login'" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Btn from '@/components/Button.vue';
    export default {
        components: {
            Btn
        },

        data() {
            return {
                email_address: "",
                password: "",
                register_url: 'https://www.loxone.com/enen/login/registration/',
                loaderVisible: false,
            }
        },

        methods: {
            login: function() {
                let email_address = this.email_address
                let password = this.password
                this.loaderVisible = true;
                this.$store.dispatch('login', { email_address, password }).catch(err => console.log(err))
            },
            
            handleErrorMessage() {
                if(this.$store.state.loginErrorMessage) {
                    this.loaderVisible = false;
                }

                switch(this.$store.state.loginErrorMessage) {
                    case 'INVALID_PASSWORD':
                        return this.$i18n.t('error.login.invalid_password');
                    case 'UNKNOWN_ERROR':
                        return this.$i18n.t('error.login.unknown_error');
                    case 'MISSING_POST_PARAMS':
                        return this.$i18n.t('error.login.missing_post_params');
                    case 'EMPTY_EMAIL_ADDRESS':
                        return this.$i18n.t('error.login.empty_email_address');
                    case 'EMPTY_PASSWORD':
                        return this.$i18n.t('error.login.empty_password');
                    case 'NO_WEBACCOUNT_FOR_THIS_EMAIL_ADDRESS':
                        return this.$i18n.t('error.login.no_webaccount_exists_for_this_email');
                    case 'WEBACCOUNT_NOT_ACTIVATED':
                        return this.$i18n.t('error.login.webaccount_not_activated');
                    case 'TOO_MANY_LOGIN_ATTEMPTS':
                        return this.$i18n.t('error.login.too_many_login_attempts');
                }
            }
        },

        watch: {
            '$store.state.loginErrorMessage': {
                deep: true,
                handler() {
                    if(this.$store.state.loginErrorMessage != "") {
                        this.handleErrorMessage();
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/utilities/variables';
    @import '../scss/pages/login';

    .login__wrapper--loading{
        text-align: center;

        svg{
            animation: wiggle 2.5s infinite;
        }
    }

    .login__error{
        margin-bottom: 40px;
    }

    @keyframes wiggle {
        0% { transform: rotate(0deg); }
        5% { transform: rotate(5deg); }
        15% { transform: rotate(-5deg); }
        20% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        35% { transform: rotate(-5deg); }
        40% { transform: rotate(0deg); }
        45% { transform: rotate(5deg); }
        55% { transform: rotate(-5deg); }
        70% { transform: rotate(0deg); }
        65% { transform: rotate(5deg); }
        75% { transform: rotate(-5deg); }
        80% { transform: rotate(0deg); }
        85% { transform: rotate(5deg); }
        95% { transform: rotate(-5deg); }
        100% { transform: rotate(0deg); }
    }
</style>